import React, { useState, useEffect } from "react";
import { ReactComponent as AvatarIcon } from "assets/img/icons/avatar-light-icon.svg";
import "assets/scss/partials/ai-assistant.scss";
import classNames from "classnames";
import { useAIContext } from "store/contexts/aiContext";
import AIAvatar from "components/AI-Assistant/AI-Avatar/AI-Avatar";
import Summerizer from "components/AI-Assistant/Summerizer/Summerizer";
import { ReactComponent as MeetingSummarizer } from "assets/img/icons/meeting-icon.svg";
import { useCreatePostContext } from "store/contexts/createPostContext";
import InnovativeTools from "components/InnovativeTools/InnovativeTools";

function AIOptions() {
  const { setAiOption, aiOption, formik, setError, disableInnovationTool } = useAIContext();
  const { sOption } = useCreatePostContext();
  const [allOptions, setAllOptions] = useState([
    {
      id: 1,
      name: "ReTeam Avatar",
      icon: <AvatarIcon className="ai-avatar-icon" />,
    },
    {
      id: 2,
      name: "Summarizer",
      icon: <MeetingSummarizer className="ai-avatar-icon" height={25} width={25} />,
    },
  ]);

  const brightIdeaOption = {
    brightIdea: [
      {
        id: 1,
        name: "ReTeam Avatar",
        icon: <AvatarIcon className="ai-avatar-icon" />,
      },
      {
        id: 2,
        name: "Summarizer",
        icon: <MeetingSummarizer className="ai-avatar-icon" height={25} width={25} />,
      },
    ],
    announcement: [
      {
        id: 1,
        name: "ReTeam Avatar",
        icon: <AvatarIcon className="ai-avatar-icon" />,
      },
      {
        id: 2,
        name: "Announce Gen",
        icon: <MeetingSummarizer className="ai-avatar-icon" height={25} width={25} />,
      },
    ],
  };

  useEffect(() => {
    if (!sOption) return;
    setAllOptions(brightIdeaOption[sOption.status]);
    setAiOption(0);

    //eslint-disable-next-line
  }, [sOption]);

  const handleOption = (option) => {
    if (aiOption === option) return setAiOption(0);
    setAiOption(option);
    if (formik.values.attachment) {
      formik.setFieldValue("attachment", null);
    }
  };

  return (
    <>
      <AIAvatar />
      <Summerizer />
      <div className="ai-options-root">
        <div className="heading-ai">Generate your idea with our innovative tools</div>
        <div className="ai-all-options">
          {allOptions.map((option) => (
            <span
              className={classNames({
                "ai-options": true,
                "ai-option-select": aiOption === option.id ? true : false,
              })}
              key={option.id}
              onClick={() => handleOption(option.id)}
            >
              <span>{option.icon}</span>
              <span className="ai-option-name">{option.name}</span>
            </span>
          ))}
          {!disableInnovationTool && (
            <InnovativeTools
              query={formik.values.text}
              setError={setError}
              aiOption={aiOption}
              setAiOption={setAiOption} />
          )}
        </div>
      </div>
    </>
  );
}

export default AIOptions;
